module.exports = __webpack_public_path__ + "img/white-arrow.f7386039.png";